/* Fidget Critter - Fractal Puzzle Designer UI. Uses FCFractal (fc-fractal-engine.js).
 * v3 2026-10-21: URL params ?code=FC-...&color=<name>&files=1 (staff cut-file panel, auto-downloads both SVGs once),
 * optional store mode (config in #fcfp-cfg: variants, prices, cut-files link) with Add to cart -> /cart/add.js.
 * v5 2026-10-25: customer pattern-number display + copy buttons removed.
 * v6 2026-10-25: Save image to device — PNG of the live preview for assembly reference (not cut files).
 * v7 2026-10-25: Save image button fill follows the chosen puzzle color.
 * v8 2026-10-25: Optional puzzle top cover checkbox — $2.95 (3.5") / $4.95 (10"), wired to selected size.
 * Same file is used inline in the local prototype and as BOLD assets/fc-fractal-designer.js. Exports unchanged. */
(function () {
  "use strict";
  var F = window.FCFractal;
  var NS = "http://www.w3.org/2000/svg";
  var COLORS = [
    { id: "red", name: "Red", hex: "#c8202f" },
    { id: "orange", name: "Orange", hex: "#f2701c" },
    { id: "yellow", name: "Yellow", hex: "#f7c815" },
    { id: "green", name: "Green", hex: "#2f8f46" },
    { id: "white", name: "White", hex: "#f4f2ec", test: true }
  ];
  var BASE = { name: "black", hex: "#1b1b1e" }; // the base (backing layer) is always black acrylic
  var SPEED = 5; // mm/s, rough diode estimate for 3 mm opaque acrylic (test-cut first)

  var st = { shape: "square", size: "10", style: "curvy", pieces: 120, seed: 4821, color: "yellow" };
  var CFG = (function () { var e = document.getElementById("fcfp-cfg"); if (!e) return null; try { return JSON.parse(e.textContent); } catch (x) { return null; } })();
  var Q = (function () { try { return new URLSearchParams(location.search); } catch (x) { return { get: function () { return null; } }; } })();
  var STAFF = Q.get("files") === "1";
  // Store mode hides test colors (White) from customers; the staff link and the local prototype show every color.
  if (CFG && !STAFF) COLORS = COLORS.filter(function (c) { return !c.test; });
  function colorFrom(v) {
    v = String(v || "").trim().toLowerCase(); if (!v) return null;
    for (var i = 0; i < COLORS.length; i++) if (COLORS[i].id === v || COLORS[i].name.toLowerCase() === v) return COLORS[i].id;
    return null;
  }
  var res = null, timer = null;
  function $(id) { return document.getElementById(id); }
  function col(id) { for (var i = 0; i < COLORS.length; i++) if (COLORS[i].id === id) return COLORS[i]; return COLORS[0]; }
  function newSeed() { return 1 + Math.floor(Math.random() * 99998); }
  function inkFor(hex) {
    var n = parseInt(String(hex).replace("#", ""), 16); if (isNaN(n)) return "#ffffff";
    var r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
    var L = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
    return L > 0.55 ? "#2b1f4f" : "#ffffff";
  }
  function paintSaveBtn() {
    var btn = $("pvSaveImg"); if (!btn) return;
    var hex = col(st.color).hex;
    btn.style.background = hex;
    btn.style.borderColor = hex;
    btn.style.color = inkFor(hex);
  }

  function shade(hex, amt) { // amt -1..1
    var n = parseInt(hex.slice(1), 16), r = n >> 16, g = (n >> 8) & 255, b = n & 255;
    function c(v) { return Math.max(0, Math.min(255, Math.round(amt < 0 ? v * (1 + amt) : v + (255 - v) * amt))); }
    return "#" + ((1 << 24) + (c(r) << 16) + (c(g) << 8) + c(b)).toString(16).slice(1);
  }
  // Preview-only piece colours: every piece gets its own bright colour (golden-angle hues, never dark),
  // assigned greedily so touching pieces get far-apart hues. Does not affect any export.
  function pieceColors(res) {
    var pcs = res.jig.pieces, n = pcs.length, owner = {}, i, j;
    pcs.forEach(function (p, k) { p.forEach(function (c) { owner[c.p1.x + "," + c.p1.y] = k; owner[c.p2.x + "," + c.p2.y] = k; }); });
    var nb = []; for (i = 0; i < n; i++) nb.push({});
    Object.keys(owner).forEach(function (key) {
      var a = owner[key], xy = key.split(","), x = +xy[0], y = +xy[1];
      [[1, 0], [0, 1], [-1, 0], [0, -1], [1, 1], [1, -1], [-1, 1], [-1, -1]].forEach(function (d) {
        var b = owner[(x + d[0]) + "," + (y + d[1])];
        if (b !== undefined && b !== a) { nb[a][b] = 1; nb[b][a] = 1; }
      });
    });
    var pal = [];
    for (i = 0; i < n; i++) pal.push({ h: (i * 137.508 + 8) % 360, s: 80 + (i % 3) * 6, l: 50 + ((i * 2) % 3) * 6 }); // L 50..62%: bright, never black
    function hd(a, b) { var d = Math.abs(a.h - b.h) % 360; return Math.min(d, 360 - d) + Math.abs(a.l - b.l) * 0.8; }
    var order = []; for (i = 0; i < n; i++) order.push(i);
    order.sort(function (a, b) { return Object.keys(nb[b]).length - Object.keys(nb[a]).length || a - b; });
    var used = new Array(n).fill(false), out = new Array(n);
    order.forEach(function (k) {
      var ns = Object.keys(nb[k]).map(Number).filter(function (m) { return out[m]; }), best = -1, bs = -1;
      for (j = 0; j < n; j++) {
        if (used[j]) continue;
        var sc = 1e9; ns.forEach(function (m) { sc = Math.min(sc, hd(pal[j], out[m])); });
        if (sc > bs) { bs = sc; best = j; }
        if (!ns.length) break;
      }
      used[best] = true; out[k] = pal[best];
    });
    return out.map(function (c) { return "hsl(" + c.h.toFixed(1) + "," + c.s + "%," + c.l + "%)"; });
  }
  function el(tag, attrs, parent) { var e = document.createElementNS(NS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); if (parent) parent.appendChild(e); return e; }

  function toast(msg) { var t = $("toast"); t.textContent = msg; t.classList.add("on"); clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove("on"); }, 1800); }

  // ---------- generation ----------
  function regen() {
    var L = F.layout(st), R = F.pieceRange(L);
    st.pieces = Math.min(R.max, Math.max(R.min, st.pieces));
    var rg = $("pcRange"); rg.min = R.min; rg.max = R.max; rg.value = st.pieces;
    $("pcMin").textContent = R.min + " · easier"; $("pcMax").textContent = "harder · " + R.max;
    res = F.generate({ shape: st.shape, size: st.size, style: st.style, pieces: st.pieces, seed: st.seed });
    draw(); sync();
  }
  function schedule(ms) { $("stage").classList.add("busy"); clearTimeout(timer); timer = setTimeout(function () { regen(); $("stage").classList.remove("busy"); }, ms || 0); }

  function draw() {
    var L = res.layout, S = L.S, sv = $("pv"), pad = S * 0.02;
    sv.setAttribute("viewBox", (-pad) + " " + (-pad) + " " + (S + 2 * pad) + " " + (S + 2 * pad));
    while (sv.firstChild) sv.removeChild(sv.firstChild);
    var pc = col(st.color).hex, out = F.outlinePath(L, st.shape), lift = S * 0.012;
    var defs = el("defs", {}, sv);
    var g = el("linearGradient", { id: "sheen", x1: "0", y1: "0", x2: "1", y2: "1" }, defs);
    el("stop", { offset: "0", "stop-color": "#fff", "stop-opacity": ".28" }, g);
    el("stop", { offset: ".45", "stop-color": "#fff", "stop-opacity": "0" }, g);
    el("stop", { offset: "1", "stop-color": "#000", "stop-opacity": ".18" }, g);
    var cp = el("clipPath", { id: "clipOut" }, defs); el("path", { d: F.outlinePath(L, st.shape) }, cp);
    // black base (backing layer) peeking out under the stack
    el("path", { d: out, transform: "translate(" + lift + "," + lift + ")", fill: BASE.hex, stroke: "#000", "stroke-width": 0.6, "data-role": "base" }, sv);
    // frame (same colour as pieces); the cut lines show the black base through the gaps
    el("path", { d: out, fill: shade(pc, -0.06), stroke: shade(pc, -0.4), "stroke-width": 0.6, "data-role": "frame" }, sv);
    var rnd = F.shadeRng(st.seed * 7 + 3), gp = el("g", { "data-role": "pieces", "stroke-linejoin": "round" }, sv);
    var edge = BASE.hex, sw = Math.max(0.5, L.rad / 8);
    var pcol = pieceColors(res);
    res.piecePaths.forEach(function (d, k) {
      el("path", { d: d, fill: pcol[k], stroke: edge, "stroke-width": sw, "data-piece": k }, gp);
    });
    el("path", { d: out, fill: "url(#sheen)", "pointer-events": "none" }, sv);
    // cut length estimate
    var len = 0, tmp = el("g", { visibility: "hidden" }, sv);
    F.cutPaths(res).concat([F.outlinePath(L, st.shape)]).forEach(function (d) { len += el("path", { d: d }, tmp).getTotalLength(); });
    sv.removeChild(tmp);
    res.cutLen = len;
    drawBacking();
  }

  function drawBacking() {
    var L = res.layout, S = L.S, b = $("bk");
    b.setAttribute("viewBox", "0 0 " + S + " " + S);
    while (b.firstChild) b.removeChild(b.firstChild);
    el("path", { d: F.outlinePath(L, st.shape), fill: BASE.hex, stroke: "#000", "stroke-width": 1 }, b);
  }

  // ---------- UI sync ----------
  function sync() {
    document.querySelectorAll("[data-group]").forEach(function (gr) {
      var k = gr.getAttribute("data-group"), cur = st[k];
      gr.querySelectorAll("[data-val]").forEach(function (b) { b.setAttribute("aria-checked", String(b.getAttribute("data-val") === cur)); b.tabIndex = 0; });
    });
    document.querySelectorAll("[data-sw]").forEach(function (gr) {
      var k = gr.getAttribute("data-sw");
      gr.querySelectorAll(".sw").forEach(function (b) { b.setAttribute("aria-checked", String(b.getAttribute("data-val") === st[k])); });
    });
    $("sizeHd").textContent = (st.shape === "round" ? "Round" : "Square") + " size";
    document.querySelectorAll("[data-group=size] .szl").forEach(function (e) { e.textContent = e.parentNode.getAttribute("data-val") + '" ' + st.shape; });
    var c = F.code(st), L = res.layout;
    if ($("codeOut")) $("codeOut").textContent = c;
    $("pcVal").textContent = st.pieces;
    $("actual").textContent = res.pieces + " pieces in this pattern";
    $("stPieces").textContent = res.pieces;
    $("stSize").textContent = st.size + '"';
    $("stMm").textContent = Math.round(L.S) + " mm " + st.shape;
    $("pvBadge").textContent = st.size + '" ' + st.shape + " · " + colorLabel();
    paintSaveBtn();
    try {
      if (Q.get("code")) { var u = new URL(location.href); u.searchParams.set("code", c); u.searchParams.set("color", col(st.color).name); u.hash = ""; history.replaceState(null, "", u.toString()); }
      else history.replaceState(null, "", "#" + c);
    } catch (e) {}
    var mins = res.cutLen / SPEED / 60;
    var rows = [
      ["Shape & size", st.size + '" ' + st.shape + " (" + Math.round(L.S) + " × " + Math.round(L.S) + " mm)"],
      ["Colors", colorLabel() + (col(st.color).test ? " (white = test color)" : "")],
      ["Acrylic", "3 mm solid · puzzle layer + black base"],
      ["Pieces", res.pieces + " (" + st.style + " style)"],
      ["Pattern number", c],
      ["Laser estimate", (res.cutLen / 1000).toFixed(1) + " m of cutting ≈ " + Math.round(mins) + " min (rough, test-cut first)"]
    ];
    var tb = $("sum"); tb.innerHTML = "";
    if (CFG && !STAFF) rows.pop(); // laser estimate is for the workshop, not customers
    rows.forEach(function (r) { var tr = tb.insertRow(), th = document.createElement("th"); th.textContent = r[0]; tr.appendChild(th); tr.insertCell().textContent = r[1]; });
    syncCart(); syncStaff();
  if ($("topCover")) $("topCover").addEventListener("change", function () { syncCart(); });
  }

  // ---------- store: price + add to cart ----------
  function variantFor() {
    var vs = (CFG && CFG.variants) || [];
    for (var i = 0; i < vs.length; i++) if (vs[i].size === st.size && vs[i].shape === st.shape) return vs[i];
    return null;
  }
  function coverWanted() {
    var el = $("topCover");
    return !!(el && el.checked);
  }
  function coverVariantFor() {
    var vs = (CFG && CFG.coverVariants) || [];
    for (var i = 0; i < vs.length; i++) if (vs[i].size === st.size) return vs[i];
    return null;
  }
  function coverCents() {
    var cv = coverVariantFor();
    if (cv && cv.price) return cv.price;
    var p = (CFG && CFG.coverPrices) || {};
    return Math.round(((p[st.size] != null ? p[st.size] : 0) || 0) * 100);
  }
  function money(cents) { return "$" + (cents / 100).toFixed(2); }
  function cutFilesUrl() {
    var b = (CFG && CFG.cutBase) || (location.origin + location.pathname), sep = b.indexOf("?") < 0 ? "?" : "&";
    return b + sep + "code=" + encodeURIComponent(F.code(st)) + "&color=" + encodeURIComponent(col(st.color).name) + "&files=1";
  }
  function cartProps() {
    var L = res.layout;
    var props = {
      "Pattern number": F.code(st),
      "Size": st.size + '"',
      "Shape": st.shape === "round" ? "Round" : "Square",
      "Color": col(st.color).name,
      "Pieces": String(res.pieces),
      "Style": st.style === "blocky" ? "Blocky" : "Curvy",
      "_Cut files": cutFilesUrl()
    };
    if (coverWanted()) props["Top cover"] = "Yes (" + st.size + '\")';
    else props["Top cover"] = "No";
    return props;
  }
  function coverProps() {
    return {
      "For pattern": F.code(st),
      "Puzzle size": st.size + '"',
      "Shape": st.shape === "round" ? "Round" : "Square"
    };
  }
  var adding = false;
  function syncCart() {
    var btn = $("addCart"); if (!CFG || !btn) return;
    var v = variantFor(), pr = $("cartPrice"), msg = $("cartMsg");
    var cents = v ? v.price : Math.round(((CFG.prices || {})[st.size] || 0) * 100);
    if (coverWanted()) cents += coverCents();
    if (pr) pr.textContent = cents ? money(cents) : "";
    var cl = $("topCoverPrice");
    if (cl) cl.textContent = money(coverCents());
    var ok = !!(v && v.available);
    btn.disabled = !ok || adding;
    btn.setAttribute("data-state", ok ? "ready" : "soon");
    if (!adding) btn.textContent = ok ? "Add to cart" : "Coming soon";
    if (msg && !adding) { msg.hidden = ok; if (!ok) msg.textContent = CFG.soonText || "Fractal puzzles are coming soon. Save your pattern number and check back!"; }
  }
  function addToCart() {
    var v = variantFor(), btn = $("addCart"), msg = $("cartMsg");
    if (!v || !v.available || adding) { syncCart(); return; }
    adding = true; btn.disabled = true; btn.textContent = "Adding...";
    var items = [{ id: v.id, quantity: 1, properties: cartProps() }];
    if (coverWanted()) {
      var cv = coverVariantFor();
      if (!cv || !cv.available) {
        adding = false; syncCart();
        if (msg) { msg.hidden = false; msg.textContent = "Top cover is not available for this size right now."; }
        return;
      }
      items.push({ id: cv.id, quantity: 1, properties: coverProps() });
    }
    var body = { items: items };
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || "/") + "cart/add.js", {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (x) {
        if (!x.ok) throw new Error((x.j && (x.j.description || x.j.message)) || "Could not add to cart");
        location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || "/") + "cart";
      })
      .catch(function (e) {
        adding = false; syncCart();
        if (msg) { msg.hidden = false; msg.textContent = "Sorry, this couldn't be added to your cart right now (" + e.message + "). Please try again, or email us your pattern number " + F.code(st) + "."; }
      });
  }

  // ---------- staff: cut files panel (?files=1) ----------
  var autoDone = false;
  function syncStaff() {
    var p = $("staffFiles"); if (!p) return;
    p.hidden = !STAFF; if (!STAFF) return;
    var L = res.layout, d = $("staffInfo");
    if (d) d.textContent = F.code(st) + " · " + st.size + '" ' + st.shape + " (" + Math.round(L.S) + " mm) · " + col(st.color).name + " · " + res.pieces + " pieces · " + st.style;
    var a = $("staffCut"), b = $("staffBase");
    if (a) a.textContent = "⬇ fidget-critter-" + F.code(st) + "-puzzle-cut.svg";
    if (b) b.textContent = "⬇ fidget-critter-" + F.code(st) + "-black-base.svg";
    if (!autoDone) { autoDone = true; setTimeout(function () { saveCut(); setTimeout(saveBase, 600); toast("Downloading 2 files: puzzle cut + black base"); }, 400); }
  }

  // ---------- downloads ----------
  function save(name, text) {
    var blob = new Blob([text], { type: "image/svg+xml" });
    var a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = name;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
  }
  function colorLabel() { return col(st.color).name + " frame & pieces on black base"; }
  function backingSVG() {
    var L = res.layout, S = F.fmt(L.S);
    return '<?xml version="1.0" encoding="UTF-8"?>\n<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="' + S + 'mm" height="' + S + 'mm" viewBox="0 0 ' + S + " " + S + '">\n' +
      "<title>Fidget Critter black base " + F.code(st) + "</title>\n" +
      "<desc>Black base (backing layer), 3 mm black acrylic. Cut outline only (0.1 mm hairline), no engraving. Units: mm.</desc>\n" +
      '<g id="cut" fill="none" stroke="#000000" stroke-width="0.1"><path d="' + F.outlinePath(L, st.shape) + '"/></g>\n' +
      "</svg>\n";
  }
  function saveCut() { save("fidget-critter-" + F.code(st) + "-puzzle-cut.svg", F.cutSVG(res)); }
  function saveBase() { save("fidget-critter-" + F.code(st) + "-black-base.svg", backingSVG()); }
  // Customer reference PNG of the colorful live preview (assembly aid). Never the laser cut profile.
  function saveImage() {
    var sv = $("pv"); if (!sv || !res) return;
    var clone = sv.cloneNode(true);
    clone.setAttribute("xmlns", NS);
    var xml = new XMLSerializer().serializeToString(clone);
    var url = URL.createObjectURL(new Blob([xml], { type: "image/svg+xml;charset=utf-8" }));
    var img = new Image();
    img.onload = function () {
      var size = 1400, c = document.createElement("canvas");
      c.width = size; c.height = size;
      var ctx = c.getContext("2d");
      ctx.fillStyle = "#fffcf6";
      ctx.fillRect(0, 0, size, size);
      ctx.drawImage(img, 0, 0, size, size);
      URL.revokeObjectURL(url);
      c.toBlob(function (blob) {
        if (!blob) { toast("Could not save image"); return; }
        var a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = "fidget-critter-" + F.code(st) + "-reference.png";
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
        setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
        toast("Saved image to your device");
      }, "image/png");
    };
    img.onerror = function () { URL.revokeObjectURL(url); toast("Could not save image"); };
    img.src = url;
  }

  // ---------- events ----------
  function bind() {
    // swatches
    document.querySelectorAll("[data-sw]").forEach(function (gr) {
      COLORS.forEach(function (c) {
        var b = document.createElement("button"); b.type = "button"; b.className = "sw"; b.setAttribute("role", "radio"); b.setAttribute("data-val", c.id);
        b.setAttribute("aria-label", c.name + (c.test ? " (test color)" : ""));
        b.innerHTML = '<i style="background:' + c.hex + '"></i>' + c.name + (c.test ? '<span class="tag">test</span>' : "");
        gr.appendChild(b);
      });
      gr.addEventListener("click", function (e) { var b = e.target.closest(".sw"); if (!b) return; st[gr.getAttribute("data-sw")] = b.getAttribute("data-val"); draw(); sync(); });
    });
    document.querySelectorAll("[data-group]").forEach(function (gr) {
      gr.addEventListener("click", function (e) {
        var b = e.target.closest("[data-val]"); if (!b) return;
        var k = gr.getAttribute("data-group"), v = b.getAttribute("data-val");
        if (st[k] === v) return;
        if (k === "size" || k === "shape") { // keep the same difficulty feel when the grid changes
          var oldR = F.pieceRange(F.layout(st)), frac = (st.pieces - oldR.min) / Math.max(1, oldR.max - oldR.min);
          st[k] = v;
          var nr = F.pieceRange(F.layout(st)); st.pieces = Math.round(nr.min + frac * (nr.max - nr.min));
        } else st[k] = v;
        schedule(0);
      });
    });
    $("pcRange").addEventListener("input", function () { st.pieces = +this.value; $("pcVal").textContent = st.pieces; schedule(90); });
    document.addEventListener("click", function (e) {
      var b = e.target.closest("[data-act]"); if (!b) return;
      var a = b.getAttribute("data-act");
      if (a === "shuffle") { st.seed = newSeed(); schedule(0); }
      else if (a === "image") saveImage();
      else if (a === "files") { saveCut(); setTimeout(saveBase, 350); toast("Saving 2 files: puzzle cut + black base"); }
      else if (a === "cut") saveCut();
      else if (a === "backing") saveBase();
      else if (a === "load") loadCode($("codeIn").value);
      else if (a === "cart") addToCart();
    });
    $("codeIn").addEventListener("keydown", function (e) { if (e.key === "Enter") loadCode(this.value); });
  }
  function loadCode(s) {
    var o = F.parseCode(s); $("codeErr").hidden = !!o; if (!o) return false;
    for (var k in o) st[k] = o[k];
    regen(); toast("Loaded " + F.code(st)); return true;
  }

  // public hooks for testing
  window.FCDesigner = { state: st, result: function () { return res; }, cutSVG: function () { return F.cutSVG(res); }, baseSVG: function () { return backingSVG(); }, load: loadCode,
    cartProps: function () { return cartProps(); }, variant: function () { return variantFor(); }, staff: STAFF };

  bind();
  // Pattern source: ?code=... (staff/cut-files link) first, then #FC-... (shared link), else a fresh random pattern.
  var qc = Q.get("code"), h = qc || decodeURIComponent((location.hash || "").slice(1)), po = h ? F.parseCode(h) : null;
  if (po) { for (var k in po) st[k] = po[k]; } else { st.seed = newSeed(); if (qc && $("codeErr")) $("codeErr").hidden = false; }
  var qcol = colorFrom(Q.get("color")); if (qcol) st.color = qcol;
  regen();
})();

